export default "__VITE_ASSET__CraRTpYc__"